module.exports = __webpack_public_path__ + "assets/edb6d2cf6bfcb56f729a56468ec63e6d.svg";